export default __webpack_public_path__ + "static/team-img1-177590a22c372c01e99833203f55d141.jpg";